(function () {
  var state = (window.strivectinRevieve = window.strivectinRevieve || {});
  var cartAddUrl =
    (window.routes && routes.cart_url ? routes.cart_url : '/cart') + '/add.js';
  var KLAVIYO_REVISION = '2025-01-15';

  function normalizeProducts(products) {
    var list = Array.isArray(products) ? products : products ? [products] : [];
    return list
      .map(function (product) {
        var id = product && (product.id || product.variant_id || product.variantId);
        if (id == null || id === '') return null;
        return {
          id: Number(id),
          quantity: Number(product.quantity) > 0 ? Number(product.quantity) : 1
        };
      })
      .filter(Boolean);
  }

  function addToCart(products) {
    var items = normalizeProducts(products);
    if (!items.length) {
      console.warn('[Revieve] onAddToCart: no valid variant IDs', products);
      return Promise.reject(new Error('No valid variant IDs'));
    }

    if (window.$s && typeof $s.showLoadingOverlay === 'function') {
      $s.showLoadingOverlay();
    }

    return fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            var error = new Error((data && data.description) || 'Add to cart failed');
            error.data = data;
            throw error;
          }
          return data;
        });
      })
      .then(function (data) {
        if (window.$s && typeof $s.addToCartSuccess === 'function') {
          $s.addToCartSuccess();
        } else if (window.SideCart && typeof SideCart.updateSideCart === 'function') {
          SideCart.updateSideCart(true);
        }
        return data;
      })
      .catch(function (error) {
        if (window.$s && typeof $s.addToCartFail === 'function') {
          $s.addToCartFail(
            (error.data && error.data.description) || error.message || 'Add to cart failed'
          );
        } else if (window.$s && typeof $s.hideLoadingOverlay === 'function') {
          $s.hideLoadingOverlay();
        }
        console.error('[Revieve] onAddToCart failed', error);
        throw error;
      });
  }

  function onAddToCart(products) {
    return addToCart(products);
  }

  function onClickProduct(product) {
    if (!product || !product.url) {
      console.warn('[Revieve] onClickProduct: missing product.url', product);
      return;
    }
    window.open(product.url, '_blank');
  }

  function onCheckout() {
    hideRevieve();
    if (window.SideCart && typeof SideCart.updateSideCart === 'function') {
      SideCart.updateSideCart(true);
      return;
    }
    window.location.assign((window.routes && routes.cart_url) || '/cart');
  }

  function hideRevieve() {
    if (window.Revieve && Revieve.API && typeof Revieve.API.hide === 'function') {
      Revieve.API.hide();
    }
  }

  /* Do not call hide() here — Revieve already closed; hide() re-fires onClose and freezes the page. */
  function onClose() {}

  function extractEmail(data) {
    if (!data) return '';
    if (typeof data === 'string' && data.indexOf('@') > -1) return data.trim();

    var candidates = [
      data.email,
      data.userEmail,
      data.Email,
      data.activeSelections && data.activeSelections.email,
      data.data && data.data.email,
      data.data && data.data.activeSelections && data.data.activeSelections.email
    ];
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (typeof c === 'string' && c.indexOf('@') > -1) return c.trim();
      if (c && typeof c.email === 'string' && c.email.indexOf('@') > -1) return c.email.trim();
    }

    /* One more unwrap pass for { data: { ... } } wrappers */
    if (data.data && typeof data.data === 'object' && data.data !== data) {
      var nested = extractEmail(data.data);
      if (nested) return nested;
    }
    return '';
  }

  function unwrapAdvisorPayload(data) {
    if (!data || typeof data !== 'object') return {};
    var current = data;
    for (var depth = 0; depth < 5; depth++) {
      /* Already at the quiz payload level */
      if (current.products || current.cvData || current.activeRoutine || current.activeFilters) {
        return current;
      }
      /* Revieve often wraps as { data: { ...quiz }, error: null } or nested data.data */
      if (current.data && typeof current.data === 'object') {
        current = current.data;
        continue;
      }
      break;
    }
    return current;
  }

  function looksLikeProduct(item) {
    if (!item || typeof item !== 'object' || Array.isArray(item)) return false;
    return (
      item.name != null ||
      item.title != null ||
      item.id != null ||
      item.image != null ||
      item.parent_id != null
    );
  }

  /** Collect product-like objects from any nested Revieve products structure (daily / Day skincare / etc.). */
  function collectProductsDeep(node, out, seen) {
    out = out || [];
    seen = seen || [];
    if (!node || typeof node !== 'object') return out;
    if (seen.indexOf(node) !== -1) return out;
    seen.push(node);

    if (Array.isArray(node)) {
      node.forEach(function (item) {
        if (looksLikeProduct(item)) out.push(item);
        else collectProductsDeep(item, out, seen);
      });
      return out;
    }

    Object.keys(node).forEach(function (key) {
      collectProductsDeep(node[key], out, seen);
    });
    return out;
  }

  function productsFromGroup(group) {
    if (!group) return [];
    /* StriVectin uses daily.all — doc sample uses Day skincare.standard */
    if (Array.isArray(group.all)) return group.all;
    if (Array.isArray(group.standard)) return group.standard;
    if (Array.isArray(group.premium)) return group.premium;
    if (Array.isArray(group)) return group;
    var collected = collectProductsDeep(group, [], []);
    if (collected.length) return collected;
    var keys = Object.keys(group);
    for (var i = 0; i < keys.length; i++) {
      if (Array.isArray(group[keys[i]])) return group[keys[i]];
    }
    return [];
  }

  function findProductGroup(products, preferredNames) {
    if (!products || typeof products !== 'object') return [];
    for (var i = 0; i < preferredNames.length; i++) {
      if (products[preferredNames[i]]) return productsFromGroup(products[preferredNames[i]]);
    }
    var lowerKeys = Object.keys(products);
    for (var j = 0; j < preferredNames.length; j++) {
      var needle = preferredNames[j].toLowerCase();
      for (var k = 0; k < lowerKeys.length; k++) {
        var key = lowerKeys[k];
        var lower = key.toLowerCase();
        if (lower === needle || lower.indexOf(needle) !== -1 || needle.indexOf(lower) !== -1) {
          return productsFromGroup(products[key]);
        }
      }
    }
    return [];
  }

  function safeProductField(product, field) {
    if (!product) return '';
    var value = product[field];
    if (value == null) return '';
    if (typeof value === 'object') return '';
    return value;
  }

  function appendProductSlot(props, prefix, product, index) {
    if (!product) return;
    var n = index + 1;
    props[prefix + '_Title_' + n] = safeProductField(product, 'name') || safeProductField(product, 'title');
    props[prefix + '_url_' + n] = safeProductField(product, 'url');
    props[prefix + '_image_' + n] = safeProductField(product, 'image');
    props[prefix + '_subTitle_' + n] =
      safeProductField(product, 'manufacturer') || safeProductField(product, 'category');
  }

  /** Flatten quiz answers / filters (Revieve does not expose Q&A as cvData without selfie). */
  function flattenSelectionBag(obj, props, prefix) {
    if (!obj || typeof obj !== 'object') return;
    Object.keys(obj).forEach(function (key) {
      if (key === 'locationData') return;
      var val = obj[key];
      if (val == null) return;
      var propKey = prefix + key;
      if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean') {
        props[propKey] = String(val);
      } else if (Array.isArray(val)) {
        var simple = val.every(function (item) {
          return typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean';
        });
        if (simple) props[propKey] = val.join(', ');
      } else if (typeof val === 'object' && val.value != null && typeof val.value !== 'object') {
        props[propKey] = String(val.value);
      }
    });
  }

  function countMappedProducts(props) {
    var count = 0;
    for (var i = 1; i <= 6; i++) {
      if (props['day_product_Title_' + i] || props['night_product_Title_' + i]) count += 1;
    }
    if (props.device_Title) count += 1;
    return count;
  }

  /**
   * Flatten getAdvisorData into flat custom properties for Klaviyo profiles/emails
   * (Revieve doc “Given_Properties” / §3.2.1). Nested JSON is not usable in email templates.
   */
  function buildGivenProperties(raw) {
    var payload = unwrapAdvisorPayload(raw);
    var props = {
      custom_source: 'Revieve',
      source: 'Revieve'
    };

    if (payload.activeRoutine) props.active_routine = String(payload.activeRoutine);

    flattenSelectionBag(payload.activeSelections, props, 'answer_');
    flattenSelectionBag(payload.activeFilters, props, 'filter_');

    /* Convenience aliases used in docs / templates */
    var selections = payload.activeSelections || {};
    var filters = payload.activeFilters || {};
    if (typeof selections.skin_type === 'string') props.skin_type = selections.skin_type;
    else if (filters.skin_type && filters.skin_type.value != null) {
      props.skin_type = String(filters.skin_type.value);
    }
    if (typeof selections.gender === 'string') props.gender = selections.gender;
    if (selections.age != null && selections.age !== '') props.age = String(selections.age);
    if (selections.skin_tone != null && selections.skin_tone !== '') {
      props.skin_tone = String(selections.skin_tone);
    }
    if (selections.skin_concerns) {
      props.skin_concerns = Array.isArray(selections.skin_concerns)
        ? selections.skin_concerns.join(', ')
        : String(selections.skin_concerns);
    }

    var cvData = payload.cvData;
    var hasCv = Array.isArray(cvData) && cvData.length > 0;

    if (hasCv) {
      if (cvData[0]) {
        props.overall_name = cvData[0].name || '';
        props.overall = cvData[0].value;
      }
      for (var i = 1; i < cvData.length && i <= 16; i++) {
        if (!cvData[i]) continue;
        props['cv_' + i + '_name'] = cvData[i].name || '';
        props['cv_' + i + '_value'] = cvData[i].value;
      }
    }

    var products = payload.products;
    if (products && typeof products === 'object') {
      var groupKeys = Object.keys(products);

      var day = findProductGroup(products, [
        'Day skincare',
        'Day',
        'day',
        'daily',
        'Daily',
        'AM',
        'Morning'
      ]);
      var night = findProductGroup(products, [
        'Night skincare',
        'Night',
        'night',
        'nightly',
        'PM',
        'Evening'
      ]);
      var device = findProductGroup(products, ['Device', 'device', 'Devices']);

      if (!day.length && !night.length) {
        if (groupKeys[0]) day = productsFromGroup(products[groupKeys[0]]);
        if (groupKeys[1]) night = productsFromGroup(products[groupKeys[1]]);
        if (groupKeys[2] && !device.length) device = productsFromGroup(products[groupKeys[2]]);
      }

      if (!day.length && !night.length) {
        day = collectProductsDeep(products, [], []);
      }

      if (groupKeys[0]) props.product_group_1 = groupKeys[0];
      if (groupKeys[1]) props.product_group_2 = groupKeys[1];
      if (groupKeys[2]) props.product_group_3 = groupKeys[2];

      /* Map up to 6 products into day_product_* for StriVectin single-routine quizzes */
      var maxSlots = Math.max(day.length, 6);
      for (var d = 0; d < Math.min(maxSlots, 6); d++) {
        appendProductSlot(props, 'day_product', day[d], d);
      }
      for (var n = 0; n < 3; n++) appendProductSlot(props, 'night_product', night[n], n);

      if (device[0]) {
        props.device_Title = safeProductField(device[0], 'name') || safeProductField(device[0], 'title');
        props.device_url = safeProductField(device[0], 'url');
        props.device_image = safeProductField(device[0], 'image');
        props.device_subTitle =
          safeProductField(device[0], 'manufacturer') || safeProductField(device[0], 'category');
      }

      props.product_count = String(countMappedProducts(props));
    } else {
      console.warn('[Revieve] No products on payload after unwrap', payload);
    }

    props.has_cv_analysis = hasCv ? 'yes' : 'no';
    return props;
  }

  function getKlaviyoConfig() {
    var cfg = state.klaviyo || {};
    return {
      enabled: cfg.enabled !== false,
      companyId: cfg.companyId || 'LqNM3e',
      listId: cfg.listId || 'NJyWFb',
      metric: cfg.metric || 'revieveOnSendEmail'
    };
  }

  function cacheAdvisorData(data) {
    if (!data) return;
    state.lastAdvisorRaw = data;
    state.lastAdvisorData = unwrapAdvisorPayload(data);
  }

  function pushGivenPropertiesToKlaviyo(email, givenProperties) {
    var cfg = getKlaviyoConfig();
    if (!cfg.enabled) return;
    if (!email) {
      console.warn('[Revieve] Klaviyo push skipped: missing email');
      return;
    }
    if (!cfg.companyId || !cfg.listId || !cfg.metric) {
      console.warn('[Revieve] Klaviyo company ID, list ID, or metric missing');
      return;
    }

    var subscribeBody = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: givenProperties,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          },
          custom_source: 'Revieve'
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: cfg.listId
            }
          }
        }
      }
    };

    fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId),
      {
        method: 'POST',
        headers: { revision: KLAVIYO_REVISION, 'content-type': 'application/json' },
        body: JSON.stringify(subscribeBody)
      }
    )
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (text) {
            console.error('[Revieve] Klaviyo subscription', response.status, text || '(empty body)');
          });
        }
      })
      .catch(function (err) {
        console.error('[Revieve] Klaviyo subscription failed', err);
      });

    var eventBody = {
      data: {
        type: 'event',
        attributes: {
          properties: givenProperties,
          metric: {
            data: {
              type: 'metric',
              attributes: {
                name: cfg.metric
              }
            }
          },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: givenProperties
              }
            }
          },
          unique_id: 'revieve-' + Date.now()
        }
      }
    };

    fetch(
      'https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(cfg.companyId),
      {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: KLAVIYO_REVISION,
          'content-type': 'application/json'
        },
        body: JSON.stringify(eventBody)
      }
    )
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (text) {
            console.error('[Revieve] Klaviyo event', response.status, text || '(empty body)');
          });
        }
      })
      .catch(function (err) {
        console.error('[Revieve] Klaviyo event failed', err);
      });
  }

  function pickBestAdvisorSource() {
    var candidates = Array.prototype.slice.call(arguments);
    var best = null;
    var bestCount = -1;
    candidates.forEach(function (candidate) {
      if (!candidate) return;
      var props = buildGivenProperties(candidate);
      var count = countMappedProducts(props);
      if (count > bestCount) {
        best = candidate;
        bestCount = count;
      }
    });
    return best;
  }

  /**
   * Push to Klaviyo only when we have email + mapped products.
   * If email arrives before results (mid-quiz "Email Your Results"), queue it
   * and flush from onDisplayProducts.
   */
  function tryKlaviyoPush(email, advisorRaw, options) {
    options = options || {};
    var reason = options.reason || 'unknown';
    var allowWithoutProducts = options.allowWithoutProducts === true;
    var skipIfAlreadyPushed = options.skipIfAlreadyPushed === true;

    if (!email) return false;

    var cfg = getKlaviyoConfig();
    var source = pickBestAdvisorSource(advisorRaw, state.lastAdvisorRaw);
    if (source) cacheAdvisorData(source);

    var givenProperties = buildGivenProperties(source || advisorRaw || {});
    var productCount = countMappedProducts(givenProperties);
    var emailKey = String(email).toLowerCase();

    if (productCount < 1 && !allowWithoutProducts) {
      state.pendingKlaviyoEmail = email;
      console.warn(
        '[Revieve] Klaviyo push deferred until products are ready (' + reason + ')',
        email
      );
      return false;
    }

    if (skipIfAlreadyPushed && state.klaviyoPushedEmails && state.klaviyoPushedEmails[emailKey]) {
      state.pendingKlaviyoEmail = null;
      return true;
    }

    state.pendingKlaviyoEmail = null;
    state.klaviyoPushedEmails = state.klaviyoPushedEmails || {};
    state.klaviyoPushedEmails[emailKey] = true;

    if (!cfg.enabled) {
      console.warn('[Revieve] Klaviyo push disabled in section settings — data logged only');
      return true;
    }

    pushGivenPropertiesToKlaviyo(email, givenProperties);
    return true;
  }

  function flushPendingKlaviyo(advisorRaw, reason) {
    var email =
      state.pendingKlaviyoEmail ||
      extractEmail(advisorRaw) ||
      extractEmail(unwrapAdvisorPayload(advisorRaw));
    if (!email) return false;
    return tryKlaviyoPush(email, advisorRaw, {
      reason: reason || 'flushPending',
      skipIfAlreadyPushed: true
    });
  }

  function scheduleAdvisorEmailFlush(reason, delays) {
    if (!window.Revieve || !Revieve.API || typeof Revieve.API.getAdvisorData !== 'function') {
      return;
    }
    (delays || [0, 600, 1500, 3000]).forEach(function (ms) {
      setTimeout(function () {
        Revieve.API.getAdvisorData(function (data) {
          if (!data) return;
          cacheAdvisorData(data);
          var email = extractEmail(data) || extractEmail(unwrapAdvisorPayload(data));
          if (email) {
            state.pendingKlaviyoEmail = state.pendingKlaviyoEmail || email;
            flushPendingKlaviyo(data, reason + '@' + ms + 'ms');
          }
        });
      }, ms);
    });
  }

  /* Fallback: mid-quiz Confirm / Send email may not fire onSendEmail in some Revieve flows. */
  function bindEmailCaptureFallback() {
    if (state.emailCaptureFallbackBound) return;
    state.emailCaptureFallbackBound = true;

    document.addEventListener(
      'click',
      function (e) {
        var el = e.target && e.target.closest ? e.target.closest('button, [role="button"], a') : null;
        if (!el) return;
        var text = ((el.textContent || '') + ' ' + (el.getAttribute('aria-label') || ''))
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();
        var looksLikeEmailSubmit =
          text === 'confirm' ||
          text.indexOf('✓ confirm') !== -1 ||
          text.indexOf('confirm') === 0 ||
          text.indexOf('send email') !== -1;
        if (!looksLikeEmailSubmit) return;

        /* Only act while Revieve UI is open */
        if (!document.getElementById('revieve-container') && !document.querySelector('[class*="revieve"]')) {
          return;
        }

        scheduleAdvisorEmailFlush('clickFallback', [400, 1200, 2500, 4000]);
      },
      true
    );
  }

  /* When recommendations appear — cache data and flush any email captured earlier. */
  function onDisplayProducts() {
    if (!window.Revieve || !Revieve.API || typeof Revieve.API.getAdvisorData !== 'function') {
      return;
    }
    Revieve.API.getAdvisorData(function (data) {
      cacheAdvisorData(data);

      /*
       * Mid-quiz "Email Your Results" / Confirm often fires before products exist
       * (or without onSendEmail). Flush pending email, or email stored on advisor.
       */
      flushPendingKlaviyo(data, 'onDisplayProducts');
      scheduleAdvisorEmailFlush('onDisplayProductsRetry', [800, 2000]);
    });
  }

  /**
   * Email capture: mid-quiz Confirm OR results Share / Send email.
   * If products aren't ready yet, queue email and send from onDisplayProducts.
   */
  function onSendEmail(data) {
    var email = extractEmail(data);
    if (!email) {
      console.warn('[Revieve] onSendEmail: missing email', data);
      return;
    }

    state.pendingKlaviyoEmail = email;
    var settled = false;

    function attempt(advisorRaw) {
      if (settled) return;
      var ok = tryKlaviyoPush(email, advisorRaw || state.lastAdvisorRaw || data, {
        reason: 'onSendEmail',
        skipIfAlreadyPushed: false
      });
      if (ok) settled = true;
    }

    if (window.Revieve && Revieve.API && typeof Revieve.API.getAdvisorData === 'function') {
      try {
        Revieve.API.getAdvisorData(function (advisorData) {
          attempt(advisorData || state.lastAdvisorRaw || data);
        });
        setTimeout(function () {
          if (!settled) attempt(state.lastAdvisorRaw || data);
        }, 800);
        setTimeout(function () {
          if (!settled) attempt(state.lastAdvisorRaw || data);
        }, 2000);
        setTimeout(function () {
          if (!settled) {
            console.warn(
              '[Revieve] onSendEmail: products still not ready — waiting for onDisplayProducts',
              email
            );
          }
        }, 3500);
        return;
      } catch (err) {
        console.warn('[Revieve] getAdvisorData failed on send email', err);
      }
    }

    attempt(state.lastAdvisorRaw || data);
  }

  function showRevieve(e) {
    if (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
    if (!window.Revieve || !Revieve.API || typeof Revieve.API.show !== 'function') {
      console.warn('[Revieve] Plugin not ready yet');
      return;
    }
    Revieve.API.show();
  }

  function isQuizOpenLink(target) {
    if (!target || !target.closest) return false;
    if (target.closest('[data-revieve-quiz="open"]')) return true;
    if (target.closest('a[href="#revieve-quiz-open"]')) return true;
    if (target.closest('a[href="#quiz-modal-open"]')) return true;
    return false;
  }

  function bindCta() {
    document.addEventListener(
      'click',
      function (e) {
        if (isQuizOpenLink(e.target)) {
          showRevieve(e);
        }
      },
      true
    );
  }

  function initPlugin() {
    if (document.getElementById('revieve-plugin-loader')) return;

    state.config = {
      partner_id: state.partnerId || 'JSJYaJo7yi',
      locale: state.locale || 'en',
      env: state.env === 'prod' ? 'prod' : 'test',
      onAddToCart: onAddToCart,
      onClickProduct: onClickProduct,
      onCheckout: onCheckout,
      onClose: onClose,
      onDisplayProducts: onDisplayProducts,
      onSendEmail: onSendEmail
    };

    var rv = document.createElement('script');
    rv.id = 'revieve-plugin-loader';
    rv.src = 'https://d38knilzwtuys1.cloudfront.net/revieve-plugin-v4/revieve-plugin-loader.js';
    rv.charset = 'utf-8';
    rv.async = true;
    rv.onload = rv.onreadystatechange = function () {
      var rs = this.readyState;
      if (rs && rs !== 'complete' && rs !== 'loaded') return;
      if (!window.Revieve || typeof Revieve.Init !== 'function') return;

      Revieve.Init(state.config, function () {
        state.ready = true;
        document.dispatchEvent(new CustomEvent('revieve:ready'));
      });
    };

    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(rv, s);
  }

  state.show = showRevieve;
  state.hide = hideRevieve;
  state.addToCart = addToCart;
  state.buildGivenProperties = buildGivenProperties;

  bindCta();
  bindEmailCaptureFallback();
  initPlugin();
})();
